'use strict';

/*@ngInject*/
module.exports = function (publicObjectsService, $rootScope, $uibModal) {
	return {
		bindToController: true,
		controllerAs: 'vm',
		controller: function controller() {
			var vm = this;
			vm.selectedObject = {};
			vm.objectMapModalOpen = false;

			publicObjectsService.getTopObjects().then(function (response) {
				vm.objects = response.data;
				vm.topObjects = vm.objects;
			});

			vm.showOnMap = function (object) {
				$uibModal.open({
					template: require('./object-map-modal.directive.html'),
					controller: require('./object-map-modal.directive'),
					controllerAs: 'vm',
					size: 'lg',
					backdrop: 'static',
					keyboard: false,
					windowClass: 'center-modal',
					resolve: {
						data: function data() {
							return object;
						}
					}
				});
				$rootScope.isModalOpen = true;
			};
		},
		template: require('./top-objects-new.directive.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/top-objects.directive.js
 **/